export default __webpack_public_path__ + "static/media/H_Hamburguer.096c9460.svg";